<faro-facet-panel [header]="header" [(collapsed)]="collapsed">
    @for (option of facetOptions; track option.key) {
        <div class="option">
            <button
                class="radio"
                [class.selected]="option.key === selected?.key"
                (click)="notifySelected(option)"
            ></button>
            <span class="label">{{ option.label }}</span>
        </div>
    }
</faro-facet-panel>
